export const FETCH_ID = "FETCH_ID";

export const GET_LINES_LIST = "GET_LINES_LIST";

export const SELECT_ROUTE = "SELECT_ROUTE";

export const GET_POLYLINES_STOPS = "GET_POLYLINES_STOPS";

export const GET_ACTIVE_BUSES = "GET_ACTIVE_BUSES";

export const ACTIVE_STOP = "ACTIVE_STOP";

export const GET_ACTIVE_BLOCKS = "GET_ACTIVE_BLOCKS";

export const SET_LOADING = "SET_LOADING";

export const GET_LOCALE = "GET_LOCALE";

export const DISPATCH_ZOOM = "DISPATCH_ZOOM";

export const FETCH_DIRECTIONS = "FETCH_DIRECTIONS";

export const SELECT_STOP = "SELECT_STOP";

//* New Start Site - Get all polylines, stops and buses
export const GET_ALL_POLYLINES_STOPS = "GET_ALL_POLYLINES_STOPS";

export const GET_ALL_BUSES = "GET_ALL_BUSES";

//* New Mobile Layout
export const DISPATCH_MODAL_SETTINGS = "DISPATCH_MODAL_SETTINGS";

export const DISPATCH_MODAL_INFO_BOTTOM = "DISPATCH_MODAL_INFO_BOTTOM";

export const SHOW_LIVE_BUSES = "SHOW_LIVE_BUSES";

export const SHOW_SCHEDULED_BUSES = "SHOW_SCHEDULED_BUSES";

export const SET_GRAYSCALE_MAP = "SET_GRAYSCALE_MAP";
